import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LightsFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.56 19.16C10.5 16.78 9.88 14.22 9.88 12C9.88 9.78 10.5 7.22 11.56 4.84C16.22 5.08 21.44 7.74 21.44 12C21.44 16.26 16.22 18.92 11.56 19.16ZM2.56 6.24H8.12V8.28H2.56V6.24ZM2.56 10.94H8.12V12.98H2.56V10.94ZM2.56 15.64H8.12V17.68H2.56V15.64Z" />
    </SvgIcon>
  );
});
